// extracted by mini-css-extract-plugin
export default {"actionButton":"ManipulatorSubmenuActions_actionButton__9osMl","submenu":"ManipulatorSubmenuActions_submenu__0Tt4g"};